import { Link } from "react-router-dom";
import { Calculator, ArrowRight } from "lucide-react";

// Cross-link block shown on bill-of-sale landings and state pages to drive
// users to the calculator. Reusable so the copy stays consistent.
export default function CalculatorCrossLink({
  variant = "default",
  state = null,
  testId = "calculator-cross-link",
}) {
  const href = state
    ? `/private-sale-car-value-calculator/${state.toLowerCase().replace(/\s+/g, "-")}`
    : "/private-sale-car-value-calculator";

  if (variant === "inline") {
    return (
      <div
        data-testid={testId}
        className="my-8 p-5 rounded-xl border border-[var(--csd-primary-light)] bg-[var(--csd-primary-light)]/30 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
      >
        <div className="flex items-start gap-3">
          <Calculator className="text-[var(--csd-primary)] shrink-0 mt-0.5" size={20} />
          <p className="text-sm sm:text-[15px] text-[var(--csd-text-primary)]">
            <strong className="font-semibold">Not sure what your car is worth?</strong>{" "}
            Use our Private Sale Car Value Calculator before creating your Bill of Sale.
          </p>
        </div>
        <Link
          to={href}
          data-testid={`${testId}-cta`}
          className="csd-btn-primary px-4 py-2.5 rounded-xl text-sm font-semibold inline-flex items-center gap-2 whitespace-nowrap"
        >
          Estimate My Car's Value <ArrowRight size={14} />
        </Link>
      </div>
    );
  }

  return (
    <section data-testid={testId} className="max-w-7xl mx-auto px-6 py-12">
      <div className="rounded-2xl border border-[var(--csd-border)] bg-gradient-to-br from-[var(--csd-primary-light)]/40 to-white p-6 sm:p-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[var(--csd-primary)] font-semibold mb-2">
              <Calculator size={14} /> Free tool
            </div>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">
              Not sure what your car is worth?
            </h2>
            <p className="mt-2 text-[15px] text-[var(--csd-text-secondary)] leading-relaxed">
              Use our Private Sale Car Value Calculator before creating your Bill of Sale.
              Compare a private-party price range with trade-in to see how much more you
              could keep.
            </p>
          </div>
          <Link
            to={href}
            data-testid={`${testId}-cta`}
            className="csd-btn-primary px-5 py-3 rounded-xl text-sm font-semibold inline-flex items-center gap-2 whitespace-nowrap"
          >
            Estimate My Car's Private Sale Value <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
